export default {
  meta: import('modules/indexPage/config/meta.js'),
  mock: {
    indexPage: import('modules/indexPage/mock/mockIndexPage.js'),
  },
  api: {
    mock: import('modules/indexPage/config/mockApi.js'),
    real: import('modules/indexPage/config/realApi.js'),
  },
  routes: import('modules/indexPage/config/routes.js'),
  menu: import('modules/indexPage/config/menu.js'),
}